/**
 * Variable and include detection for prompt content.
 * Detects {keyword} patterns (variables) and {{include: name}} patterns (includes).
 */

/**
 * Extracts variable names from prompt content.
 * Matches {word} but not {{word}} or {{include: word}}.
 *
 * @param content - The prompt content to scan
 * @returns Array of unique variable names
 */
export function extractVariables(content: string): string[] {
  const matches = content.match(/(?<!\{)\{([a-zA-Z_][a-zA-Z0-9_]*)\}(?!\})/g) || []
  return [...new Set(matches.map((m) => m.slice(1, -1)))]
}

/**
 * Extracts include directives from prompt content.
 * Matches {{include: name}} and {{include?: name}} and {{include: name, var=val}}
 *
 * @param content - The prompt content to scan
 * @returns Array of unique include names (without variables or ? modifier)
 */
export function extractIncludes(content: string): string[] {
  const regex = /\{\{include\??\s*:\s*([a-zA-Z0-9_-]+)\s*(?:,\s*[^}]*)?\}\}/g
  const includes: string[] = []
  let match
  while ((match = regex.exec(content)) !== null) {
    includes.push(match[1])
  }
  return [...new Set(includes)]
}
